import { ActionType } from "../../classes/action-type";
import { CalendarAppText } from "../interfaces/calendar-app-text.state";

export function receiveText(text: CalendarAppText) {
    return {
        type: ActionType.ReceiveText,
        value: text
    }
}
